module.exports = __webpack_public_path__ + "assets/img/Five.45cbf4aa.png";